import React from "react";
import { useAuth } from "@/context/AuthContext";
import { LogIn } from "lucide-react";
import { LOGO } from "@/lib/images";

export default function AdminLogin() {
  const { user } = useAuth();

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-brand-ink px-5 text-white">
      <div className="w-full max-w-md rounded-3xl border border-white/10 bg-white/5 p-8 text-center backdrop-blur">
        <img src={LOGO} alt="VoiceOverKids" className="mx-auto h-20 w-20 object-contain" />
        <h1 className="mt-5 font-heading text-2xl font-bold">VoiceOverKids Admin</h1>
        <p className="mt-2 text-sm text-zinc-400">Staff access only. Sign in with your authorised Google account to manage the voice catalogue.</p>
        {user && !user.is_admin && (
          <p className="mt-4 rounded-xl border border-red-400/30 bg-red-500/10 p-3 text-sm text-red-300">
            {user.email} is not authorised for admin access.
          </p>
        )}
        <button onClick={login} data-testid="google-login-btn"
          className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full bg-brand-violet px-6 py-3.5 font-bold transition hover:bg-brand-violetHover">
          <LogIn size={18} /> Sign in with Google
        </button>
      </div>
    </div>
  );
}
